import { createAction, props } from '@ngrx/store';
import {
  IAccountDocumentCards,
  IAccountResourceCard,
  IApiCardResponse,
  INewCard,
  INewCardState,
} from 'src/app/api/interfaces/card.interface';
import {
  IApiAccountResponse,
  IBalances,
} from 'src/app/api/interfaces/configuration.interface';
import { IApiReferralState } from 'src/app/api/interfaces/referral.interface';

export const setStateCondition = createAction(
  'set State condition',
  props<{ ready: boolean }>()
);

export const setAccountState = createAction(
  '[State API] Get Account state success',
  props<{ responseData: IApiAccountResponse }>()
);

export const setCardState = createAction(
  '[State Api] Get Card state success',
  props<{ responseData: INewCardState }>()
);
export const updateBalance = createAction(
  '[WSS Api] update account balance',
  props<{ WssresponseData: IBalances }>()
);
export const setRefferalState = createAction(
  '[State API] set refferal state',
  props<{ responseData: IApiReferralState }>()
);
export const updateCompletedCardState = createAction(
  '[State API] update completed cards  state',
  props<{
    cardUpdate: INewCardState;
  }>()
);
